module.exports = __webpack_public_path__ + "img/earn-back.a37fdc99.svg";